var label = "Buy Now";
var EN_TRANSLATION = {
  label: label
};
export { EN_TRANSLATION as default, label };
//# sourceMappingURL=en.json.mjs.map
